// removed by extract-text-webpack-plugin
module.exports = {"pdfViewer":"PdfViewer__pdfViewer__KwsNx"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/PdfViewer/PdfViewer.scss
// module id = 1730
// module chunks = 0